export const shoppingcart = {
    title: "สรุปคำสั่งซื้อ",
    title_payment: "สั่งอาหาร",
    title_subscription: "สรุปคำสั่งซื้อ",
    status: {
        your_order: "Your Order",
        payment: "Payment"
    },
    delivery_method: {
        pickup_at: "รับที่สาขา",
        change: "เปลี่ยน",
        time: "เวลา",
        now: "ตอนนี้"
    },
    your_order_title: "รายการอาหาร",
    add_more_button: "เพิ่ม",
    baht: "บาท",
    free: "ฟรี",
    subtotal: "ยอดรวม",
    delivery_fee: "ค่าจัดส่ง",
    discount: "ส่วนลด",
    total: "ยอดสั่งซื้อทั้งหมด",
    calculating: "กำลังคำนวน",
    coupon_discount: "คูปองส่วนลด",
    no_coupon: "ใช้ข้อเสนอเพื่อรับส่วนลด",
    additional_message: "ข้อความเพิ่มเติม",
    cutlery: "ช้อนซ้อม",
    sauce: "ซอส",
    type_your_request: "กรอกข้อความ",
    total_bath: "ยอดสั่งซื้อทั้งหมด : {0} บาท",
    you_will_get_points: "คุณจะได้รับ {0} คราวพอยท์จากการสั่งซื้อออเดอร์นี้",
    checkout: "สั่งซื้อ",
    popup_upsale: {
        your_may_also_like: "คุณอาจจะชอบสิ่งนี้",
        total: "ยอดรวมปัจจุบัน {0} บาท",
        proceed_to_checkout: "สั่งอาหาร",
    },
    
    profile: {
        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์มือถือ',
            placeholder: 'เบอร์โทรศัพท์มือถือ',
            required: 'กรุณากรอกเบอร์โทรศัพท์มือถือ',
            too_short: 'Mobile no must be {0} digits',
            invalid: 'Incorrect Mobile no format',
        },
    },
    payment_method: "เลือกวิธีการชำระเงิน",
    cash: "ชำระเงินปลายทาง",
    credit: "บัตรเดบิต/ บัตรเครดิต",
    add_credit: "เพิ่มบัตรใหม่",
    request_tax: "ต้องการใบกำกับภาษี",
    placeorder: "สั่งอาหาร",
    popup_loading_driver: {
        please_wait: "กรุณารอสักครู่...",
        find_driver: "เรากำลังหาคนขับให้คุณ<br>คุณอาจจะต้องทำการยืนยันชำระเงินผ่านระบบ OTP",
        find_not_found: "ขออภัย ไม่พบคนขับ",
        try_again: "ลองใหม่",
        cancel: "ยกเลิก"
    },
    
    error_address_not_found: "กรุณาเลือกที่อยู่จัดส่งสินค้า หรือสาขาสำหรับรับอาหารที่หน้าร้าน",
    error_credit: "การชำระเงินของคุณไม่สำเร็จ กรุณาลองใหม่อีกครั้ง<br/>หากยังพบปัญหา โปรดติดต่อ 1112",
    error_cart: "สินค้าในตระกร้ามีการเปลี่ยนแปลง กรุณาตรวจสอบ",
    error_cart_item: "รายการนี้ไม่ถูกต้องสำหรับประเภทการสั่งซื้อนี้ กรุณาลบและเลือกรายการใหม่อีกครั้ง",
    error_book: "พบปัญหาที่ระบบเรียกคนขับกรุณาลองใหม่อีกครั้ง",
    error_book_2: "Error: 404",
    popup_connection_error: {
        msg: "พบปัญหาการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
        retry: "ลองอีกครั้ง",
        cancel: "ยกเลิก"
    },
    popup_contact_bk: {
        msg: "การเชื่อมต่อมีปัญหาไม่สามารถดำเนินการต่อได้  ขออภัยในความไม่สะดวก  กรุณาติดต่อ 1112 เพื่อสั่งซื้อ",
        confirm: "ยืนยัน"
    },
    popup_qr_payment: {
        title: "Payment infomation",
        total: "Total : {0} Baht",
        transaction_date: "Transaction date :",
        qr_time: "QR Code valid for",
        scan_qr_to_pay: "Scan QR code to pay",
        save_qr: "Save QR code",
        cancel: "Close"
    },
    popup_limit_order: {
        msg: "ขออภัย จำนวนรายการอาหารเต็มแล้ว กรุณาสั่งในชั่วโมงอื่นๆ",
        btn_close: "ปิด"
    }
};